import React from 'react';
import { Text } from '@amzn/stencil-react-components/text';
import { Expander } from '@amzn/stencil-react-components/expander';

export const ProductivitySupportPreviousWeekFAQSet: React.FunctionComponent = () => {
  return (
    <>
      <Expander titleText="What is UPH?">
        <Text>
          (Units Per/Hours) is the amount of units or containers an individual processes in one hour.
        </Text>
      </Expander>
      <Expander titleText="What does &quot;Percentile Ranking Compared to Peers&quot; represent?">
        <Text>
          Your &quot;Percentile Ranking Compared to Peers&quot; shows the performance percentage of eligible people at your FC across all Learning Curve Families. For example, if your Percentile Ranking Compared to Peers shows 7%, you were in the top 7% at your site and performed better than 93% of eligible people at your site.
        </Text>
      </Expander>
      <Expander titleText="Why isn't data on my performance compared to peers available?">
        <Text>
          If you don't have data on your performance compared to peers for productivity or quality during a particular week, you may not have been eligible for performance review in that category because:
        </Text>
        <Text>
          <ol type="a">
            <li>You were recently trained in the specific process path</li>
            <li>You recently returned from an extended leave or have not worked in the path for more that 90 days</li>
            <li>You have not worked more than five total hours in a path for the review week, worked in a process path that did not have enough people working in it, or if the process path does not have UPH data available.</li>
          </ol>
        </Text>
        <Text>Note: performance data for quality is pulled Monday-Monday of the prior week and productivity data is pulled Wednesday-Wednesday for the current week.</Text>
      </Expander>
      <Expander titleText="Why are some work items exempted?">
        <Text>
          Please note that your work in some Work Items below may be exempted from the determination of your overall Percentile for the Weekly Productivity Review period. A common reason for a Work Item being exempted is due to the number of hours you worked in the corresponding process not meeting a minimum number of hours. Please reach out to your manager for any questions.
        </Text>
      </Expander>
    </>
  );
}